import z from 'zod'

import { CONTRACT_SIDES } from '@/pages/instruments/new-instrument/constants/sides'

export const contractSideSchema = z.enum(CONTRACT_SIDES)
